import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Home from '../views/Home.vue'
import Tda from '../views/Tda.vue'
import Caca from '../views/Caca.vue'
import Paper from '../views/Paper.vue';
import ReportQuery from '../views/ReportQuery.vue';



Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: 'Index',
        component: Index,
        redirect: '/',
        meta: {
            title: 'CSSAT、TDA-标准学术能力测试（诊断性测试）',
            description: '标准学术能力测试(CSSAT, Comprehensive Standard Scholastic Assessment Test)是一个旨在科学评估学生学科素养、助力其学业发展的综合性评估体系。它基于学生在各学科领域应具备的知识与能力，结合大学选才视角，通过全面、客观、准确的过程性评价，长程动态地评估学生学科素养的达成度。CSSAT旨在为教师的教学和学生的学习提供精准、有效的反馈，助力教师提升教学水平，推动学生学科素养的全面提升。'
        },
        children: [
            {
                path: '/',
                name: 'home',
                component: Home,
                meta: {
                    title: 'CSSAT、TDA-标准学术能力测试（诊断性测试）',
                    description: '标准学术能力测试(CSSAT, Comprehensive Standard Scholastic Assessment Test)是一个旨在科学评估学生学科素养、助力其学业发展的综合性评估体系。它基于学生在各学科领域应具备的知识与能力，结合大学选才视角，通过全面、客观、准确的过程性评价，长程动态地评估学生学科素养的达成度。CSSAT旨在为教师的教学和学生的学习提供精准、有效的反馈，助力教师提升教学水平，推动学生学科素养的全面提升。'
                }
            },
            {
                path: '/tda',
                name: 'tda',
                component: Tda,
                key: 'tda',
                meta: {
                    title: 'CSSAT、TDA-标准学术能力测试（诊断性测试）',
                    description: '诊断性测试(TDA，Targeted Diagnostic Assessment)是以中国高考评价体系、普通高中课程方案和各个学科课程标准为依据，结合大学考查视角对学生提供对接新高考模式的诊断性评价，旨在通过科学的、客观的过程性评价，促进中学生学科素养提升，助力大中衔接。'
                }
            },
            {
                path: '/caca',
                name: 'caca',
                component: Caca,
                key: 'caca',
                meta: {
                    title: 'CSSAT、CACA-综合学术能力评估',
                    description: '综合学术能力评估(CACA，Comprehensive Academics Competency Assessment)是一个面向具备数学或物理学科特长，特别是有志于参加高中或高校数学或物理学科培养类项目选拔的学生提供的水平测试。CACA结合学科知识、核心素养、思维素质构建了从基础思维到综合能力的进阶性测评体系，旨在通过科学量化的评估与水平标定，帮助学生精准定位自身在数理领域的知识素养情况及发展潜能，为个性化学习路径规划提供数据支持。'
                }
            },
            {
                path: '/paper',
                name: 'paper',
                component: Paper,
                key: 'paper',
                meta: {
                    title: 'TDA高三精选试题与解析集',
                    description: '《诊断性测试(TDA)高三精选试题与解析集》(简称“TDA高三精选题集”)是专为高三年级学生设计的、用于新高考高效备考的习题集。TDA高三精选题集基于“做透一题胜于做过试题”的高效备考理念设计，题目全部取自诊断性测试(TDA-G12)非加试科目真题，由TDA教研团队结合高考命题规律、高考重难点和TDA考生作答表现等视角精心挑选得出，并以知识点作为专题、由若干专题组成试卷的方式来组织；每题除了配有详实的解析外，还包括易突破点、易错点和延伸知识点的总结。目前，TDA高三精选题集包含2023年和2024年的数学、物理、化学共6个学科分册。'
                }
            },
            {
                path: "/zxtest",
                name: "zxtest",
                component: ReportQuery,
                meta: {
                    title: "专项测试成绩报告查询",
                    authorization: false // 无需登录认证
                },
            }
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 解决重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        // 只忽略重复导航的错误，其他错误正常抛出
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    window.scrollTo(0, 0);
    next();
});

export default router
